import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '../../../common/styles/style-constants';

const WhiterTeeth = ({ color }) => (
  <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.321 0c.345 0 .625.28.625.625v2.679a.625.625 0 0 1-1.25 0V.625c0-.345.28-.625.625-.625zM2.587 1.962c.165 0 .324.064.443.183l1.893 1.893a.626.626 0 0 1-.885.885L2.145 3.03a.626.626 0 0 1 .442-1.068zm9.468 0a.624.624 0 0 1 .443 1.068l-1.893 1.893a.626.626 0 0 1-.885-.885l1.893-1.893a.624.624 0 0 1 .442-.183zM7.321 4.315a3.013 3.013 0 0 1 3.006 3.006 3.013 3.013 0 0 1-3.006 3.006 3.013 3.013 0 0 1-3.006-3.006 3.013 3.013 0 0 1 3.006-3.006zm0 1.25a1.75 1.75 0 0 0-1.756 1.756c0 .975.781 1.756 1.756 1.756a1.75 1.75 0 0 0 1.756-1.756 1.75 1.75 0 0 0-1.756-1.756zM.625 6.696h2.679a.625.625 0 0 1 0 1.25H.625a.625.625 0 0 1 0-1.25zm10.714 0h2.679a.625.625 0 0 1 0 1.25h-2.679a.625.625 0 0 1 0-1.25zM4.48 9.538a.624.624 0 0 1 .443 1.067L3.03 12.498a.626.626 0 0 1-.885-.885L4.038 9.72a.624.624 0 0 1 .442-.182zm5.683 0c.165 0 .324.064.442.182l1.893 1.893a.626.626 0 0 1-.885.885L9.72 10.605a.626.626 0 0 1 .443-1.067zM7.32 10.714c.345 0 .625.28.625.625v2.679a.625.625 0 0 1-1.25 0v-2.679c0-.345.28-.625.625-.625z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);
WhiterTeeth.defaultProps = {
  color: colors.blue,
};

WhiterTeeth.propTypes = {
  color: PropTypes.string,
};

export default WhiterTeeth;
